<div class="info-box">
  <mat-icon class="icon">info</mat-icon>
  <span class="text">{{ message }}</span>
</div>
